import React from "react";
import {
  ThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";

import data from "./theme.data";
import { usePageMode } from "@/model/usePageMode";
import CssBaseline from "@mui/material/CssBaseline";

// A theme with custom primary and secondary color.
// It's optional.
const theme = createTheme(data());
const theme2 = createTheme(data('dark'));

function withRoot(Component, mode) {
  function ComponentWrapper(props) {
    // ThemeProvider makes the theme available down the React tree
    // thanks to React context.
    const { mode } = usePageMode();
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={mode == 'dark' ? theme2 : theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          <Component {...props} />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }

  return ComponentWrapper;
}

export default withRoot;
